import React from 'react';
import { Link } from 'react-router-dom';
import { Icon } from '../components/icons';
import { SALES_STEPS, SALES_STEP_COUNT, SalesStepId, salesStepById } from './salesSteps';

export interface SalesProcessBarProps {
  /** Aktueller Schritt; ohne Angabe eine Werkzeugseite (Heute, Firmen, Postfaecher). */
  stepId?: SalesStepId;
  /** Beschriftung fuer Werkzeugseiten ohne Schritt. */
  label?: string;
  extraActions?: React.ReactNode;
}

/**
 * Prozessleiste fuer die Vertriebsseiten: wo im Ablauf bin ich, was kommt
 * davor und danach, zurueck zum Cockpit. Nutzt die Klassen der
 * LinkedIn-Schrittleiste (flow.css), damit beide gleich aussehen.
 */
export const SalesProcessBar: React.FC<SalesProcessBarProps> = ({ stepId, label, extraActions }) => {
  const step = stepId ? salesStepById(stepId) : null;
  const prev = step ? SALES_STEPS[step.index - 2] : undefined;
  const next = step ? SALES_STEPS[step.index] : undefined;

  return (
    <section
      className="flow-stepbar flow-stepbar--sales"
      aria-label={step ? `Vertriebsprozess, Schritt ${step.index} von ${SALES_STEP_COUNT}` : 'Vertrieb'}
    >
      <div className="flow-stepbar__row">
        <Link to="/vertrieb" className="flow-stepbar__home" title="Zum Vertriebs-Cockpit">
          <Icon name="target" size={14} /> Vertrieb
        </Link>
        <span className="flow-stepbar__pos">
          {step ? `Schritt ${step.index} von ${SALES_STEP_COUNT}` : label ?? 'Werkzeug'}
        </span>
        <ol className="flow-dots" aria-label="Vertriebsschritte">
          {SALES_STEPS.map((s) => (
            <li key={s.id}>
              <Link
                to={s.path}
                className={`flow-dot flow-dot--ready${s.id === stepId ? ' is-current' : ''}`}
                aria-current={s.id === stepId ? 'step' : undefined}
                title={`${s.index} · ${s.label}`}
                aria-label={`${s.index} · ${s.label}`}
              >
                {s.index}
              </Link>
            </li>
          ))}
        </ol>
        <div className="flow-stepbar__nav">
          {extraActions}
          {prev && (
            <Link to={prev.path} className="btn btn-ghost btn-sm" title={prev.label}>
              <Icon name="arrow-left" size={14} /> {prev.index} · {prev.shortLabel}
            </Link>
          )}
          {next && (
            <Link to={next.path} className="btn btn-ghost btn-sm" title={next.label}>
              {next.index} · {next.shortLabel} <Icon name="arrow-right" size={14} />
            </Link>
          )}
          {!step && (
            <Link to="/vertrieb" className="btn btn-ghost btn-sm">
              Zum Cockpit <Icon name="arrow-right" size={14} />
            </Link>
          )}
        </div>
      </div>
    </section>
  );
};

export default SalesProcessBar;
